var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.applicationMaintenance)?_c('Maintenance'):_c('AppDashboard',{attrs:{"context":_vm.context}})
}
var staticRenderFns = []

export { render, staticRenderFns }